import * as angular from 'angular';
import { config } from 'angular/utils/config';

class StorageFcfsOfferDetailsComponentCtrl implements ng.IController {
    public stageConfig = config;
}

angular.module('app').component('pkpStorageFcfsOfferDetails', {
    controller: StorageFcfsOfferDetailsComponentCtrl,
    template:
        require('app/storage-booking-wizard/storage-fcfs-offer-details.component.html'),
    bindings: {
        requestHeader: '=',
        responseHeader: '=',
        offer: '=',
        request: '=',
        response: '=',
        attachmentList: '=',
        selectedAlt: '=',
        ssoName: '='
    }
});
